import { useEffect, useState } from 'react'
import { Link, NavLink, Outlet, Navigate, useLocation } from 'react-router-dom'
import { api } from '../api'
import { Loading } from '../Loading'

export function AdminLayout() {
  const [user, setUser] = useState<{ username: string; role: string } | null | undefined>(undefined)
  const { pathname } = useLocation()

  useEffect(() => {
    void api
      .me()
      .then((r) => setUser(r.user ? { username: r.user.username, role: r.user.role } : null))
      .catch(() => setUser(null))
  }, [pathname])

  if (user === undefined) return <Loading />
  if (!user) return <Navigate to="/admin/login" replace />

  return (
    <div className="admin-root">
      <nav className="admin-nav">
        <div className="layout">
          <div className="admin-nav-links">
            <NavLink to="/admin/events" className={({ isActive }) => `nav-link${isActive ? ' active' : ''}`}>
              <span className="nav-icon">📅</span>
              <span>活動</span>
            </NavLink>
            {user.role === 'super_admin' && (
              <NavLink to="/admin/users" className={({ isActive }) => `nav-link${isActive ? ' active' : ''}`}>
                <span className="nav-icon">👥</span>
                <span>管理員</span>
              </NavLink>
            )}
            <NavLink to="/admin/profile" className={({ isActive }) => `nav-link${isActive ? ' active' : ''}`}>
              <span className="nav-icon">👤</span>
              <span>帳號</span>
            </NavLink>
          </div>
          <div className="row">
            <div className="muted" style={{ fontSize: '0.85rem', marginRight: '0.5rem' }}>
              {user.username}
            </div>
            <button
              className="btn btn-sm"
              type="button"
              onClick={() => void api.logout().then(() => (window.location.href = '/admin/login'))}
            >
              登出
            </button>
          </div>
        </div>
      </nav>
      <div className="admin-content" style={{ padding: '0 1rem 2rem' }}>
        <div className="layout">
          <Outlet context={{ user }} />
        </div>
      </div>
    </div>
  )
}
